import { Box, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useEffect, useState } from "react";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";

export function ContactsFilter({ onFiltered }) {
  const [searchParam, setSearchParam] = useState("");
  const [selectedContact, setSelectedContact] = useState(null);
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (searchParam.length < 3) {
      setLoading(false);
      setOptions([]);
      return;
    }

    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchContacts = async () => {
        try {
          const { data } = await api.get("/contacts", {
            params: { searchParam },
          });
          setOptions(data.contacts);
        } catch (err) {
          toastError(err);
        } finally {
          setLoading(false);
        }
      };

      fetchContacts();
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchParam]);

  const renderContactLabel = (contact) => {
    if (!contact) return "";
    const contactNickname = contact.nickname ? ` (${contact.nickname})` : "";
    return `${contact.name}${contactNickname} - ${contact.number}`;
  };

  const handleChange = (value) => {
    setSelectedContact(value);
    onFiltered(value ? value.id : null);
  };

  const handleInputChange = (value) => {
    setSearchParam(value);
    if (value === "") {
      setSelectedContact(null);
      onFiltered(null);
    }
  };

  return (
    <Box style={{ padding: "0px 10px 10px" }}>
      <Autocomplete
        size="small"
        options={options}
        value={selectedContact}
        loading={loading}
        onChange={(event, value) => handleChange(value)}
        onInputChange={(event, value) => handleInputChange(value)}
        getOptionLabel={(option) => renderContactLabel(option)}
        getOptionSelected={(option, value) => option?.id === value?.id}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            placeholder={i18n.t("tickets.filters.contact")}
          />
        )}
      />
    </Box>
  );
}